import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import TaskCard from './TaskCard';

const CategorySection = ({ category, tasks, onTaskComplete, completedTaskIds }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const categoryTasks = tasks?.filter((task) => task?.category === category?.name);
  const completedCount = categoryTasks?.filter((task) => completedTaskIds?.includes(task?.id))?.length;
  const totalCount = categoryTasks?.length;
  const completionPercentage = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-elevation-1">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-4 flex items-center justify-between hover:bg-muted/20 transition-colors duration-150"
        aria-expanded={isExpanded}
        aria-label={`${isExpanded ? 'Collapse' : 'Expand'} ${category?.name} section`}
      >
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${category?.bgColor}`}>
            <Icon name={category?.icon} size={20} color={category?.iconColor} strokeWidth={2.5} />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-foreground">{category?.name}</h3>
            <p className="text-xs text-muted-foreground">
              {completedCount} of {totalCount} tasks completed
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden sm:flex items-center gap-2">
            <div className="w-24 h-2 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full bg-primary rounded-full transition-all duration-300"
                style={{ width: `${completionPercentage}%` }}
              />
            </div>
            <span className="text-sm font-medium text-muted-foreground">{completionPercentage}%</span>
          </div>
          <Icon
            name={isExpanded ? 'ChevronUp' : 'ChevronDown'}
            size={20}
            color="var(--color-muted-foreground)"
          />
        </div>
      </button>
      {isExpanded && (
        <div className="p-4 pt-0 space-y-3 animate-fade-in">
          {categoryTasks?.map((task) => (
            <TaskCard
              key={task?.id}
              task={task}
              onComplete={onTaskComplete}
              isCompleted={completedTaskIds?.includes(task?.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategorySection;